<script setup lang="ts">
import { Ticket, Workshop } from '@/@types/workshop'
import BackdropBg from '@/components/shared/main/BackdropBg.vue'

import videoLow from '@/assets/main/video-low.mp4'
import Details from '@/components/shared/workshops/Details.vue'
import Faq from '@/components/shared/workshops/Faq.vue'

import Hero from '@/components/shared/workshops/Hero.vue'
import Localization from '@/components/shared/workshops/Localization.vue'
import Tickets from '@/components/shared/workshops/Tickets.vue'
import DarkLayout from '@/layouts/DarkLayout.vue'
import { Head } from '@inertiajs/vue3'

defineProps<{
    tickets: Ticket[]
    workshop: Workshop
}>()
</script>

<template>
    <Head :title="$t(workshop.description)"></Head>

    <DarkLayout>
        <BackdropBg />

        <main class="pt-40 text-white lg:pt-28">
            <div class="relative z-10 container !p-0 md:!p-4">
                <div class="relative z-20 overflow-hidden rounded-[20px] p-4 py-8 md:p-8">
                    <div class="absolute inset-0 h-full w-full bg-[#0D1011]/80 backdrop-blur-[250px] md:p-8"></div>
                    <video
                        class="pointer-events-none absolute inset-0 isolation-auto -z-10 h-[570px] w-full max-w-[380px] rounded-2xl object-cover"
                        autoplay
                        muted
                        loop
                        controlsList="nofullscreen"
                        playsinline
                        preload="none"
                    >
                        <source :src="videoLow" type="video/mp4" />
                    </video>
                    <div class="isolate">
                        <Hero :workshop="workshop" />
                        <Details :workshop="workshop" />
                        <hr class="mt-8 w-full border-slate-800 pb-12" />
                        <Localization :workshop="workshop" />
                        <Tickets :tickets="tickets" v-if="tickets?.length" />
                    </div>
                </div>
                <div class="mt-12 px-4 lg:mt-24">
                    <Faq />
                </div>
            </div>
        </main>
    </DarkLayout>
</template>
